module.exports = __webpack_public_path__ + "images/psp/Icon/kayak.svg";